import { AfterContentInit, Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ParentItemProviderService } from '@app/shared';
import { normalizeOptionLabel } from '@app/shared/util/common-utils';
import { DynamicFormService, FORM_SERVICE_PROVIDER_TOKEN } from '@ntap/common';
import {
  AttributeStateService,
  ItemInfo,
  ItemViewProviderDirective,
  NtapCommonComponent,
  View
} from '@ntap/core';
import { delay, map, Observable, of, startWith, switchMap, tap } from 'rxjs';
import {
  FIZICKI_OBJEKT_PARENT_FORM,
  FIZICKI_OBJEKT_PARENT_ITEM
} from '../pojavni-oblik/pojavni-oblik.component';

@Component({
  selector: 'app-fizicki-objekt',
  templateUrl: './fizicki-objekt.component.html',
  styleUrls: ['./fizicki-objekt.component.scss'],
  providers: [
    ParentItemProviderService,
    {
      provide: FORM_SERVICE_PROVIDER_TOKEN, // FIXME trebalo bi ne koristiti ovo nego preuzeti formService iz child komponente
      useClass: DynamicFormService
    },
    {
      provide: DynamicFormService,
      useExisting: FORM_SERVICE_PROVIDER_TOKEN
    },
    {
      // re-provide context to child components
      provide: FIZICKI_OBJEKT_PARENT_ITEM,
      useExisting: ItemViewProviderDirective
    },
    {
      provide: FIZICKI_OBJEKT_PARENT_FORM,
      useExisting: FORM_SERVICE_PROVIDER_TOKEN
    }
  ]
})
export class FizickiObjektComponent
  extends NtapCommonComponent
  implements AfterContentInit
{
  private formService = inject(DynamicFormService);
  private attributeStateService = inject(AttributeStateService);
  private itemViewProvider = inject(ItemViewProviderDirective);

  viewName$: Observable<string>;
  obrazacClass: string;

  doDynamicInit() {
    this.viewName$ = this.itemViewProvider.view$.pipe(
      map((view: View) => view.name)
    );
  }

  ngAfterContentInit(): void {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          delay(0),
          switchMap((item: any) => {
            return this.formService.formGroup$.pipe(
              switchMap((fg) => {
                const vrstaControl =
                  fg.get('en~fizicki_objekt~vrsta_fizickog_objekta_id') ||
                  ({ valueChanges: of(null) } as AbstractControl);

                return vrstaControl.valueChanges.pipe(
                  startWith(
                    this.formService.getFormValue(
                      'en~fizicki_objekt~vrsta_fizickog_objekta_id'
                    )
                  ),
                  switchMap((value) => {
                    return this.fetchOptions(item).pipe(
                      tap((options) => {
                        const option = options.filter(
                          (o) => o.value === value
                        )[0] || { label: '' };
                        const normalizedLabel = normalizeOptionLabel(option);
                        this.obrazacClass = `vrsta-${normalizedLabel}`;
                      })
                    );
                  })
                );
              })
            );
          })
        )
        .subscribe()
    );
  }

  private fetchOptions(item: any) {
    return this.attributeStateService.getAllowedValues(
      {
        $fqan: 'en~fizicki_objekt~vrsta_fizickog_objekta_id',
        name: 'en~fizicki_objekt~vrsta_fizickog_objekta_id'
      },
      {
        ['en~fizicki_objekt~id']: new ItemInfo(item).id
      },
      'fizicki_objekti_item'
    );
  }
}
